import React from 'react';
import { Box } from '@mui/material';
import { Logo } from './index';
import EngGrid from './EngGrid';

const MONO = "'IBM Plex Mono', monospace";

// Split-screen layout used by all auth + checkout pages.
// Left: dark brand panel with engineering grid + teal glow + status line.
// Right: focused form area.
// Props: statusLine (string shown in mono below brand panel text), formTitle, children (form body)
export default function SplitAuthLayout({ statusLine, children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        background: '#0a1326',
        '@media (max-width:700px)': { flexDirection: 'column' },
      }}
    >
      {/* Brand panel */}
      <Box
        sx={{
          position: 'relative',
          width: { xs: '100%', sm: '42%' },
          flexShrink: 0,
          background: 'linear-gradient(180deg,#0e1c39,#081525)',
          borderRight: '1px solid rgba(120,150,200,.16)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          px: '40px',
          py: { xs: '40px', sm: '60px' },
          overflow: 'hidden',
          '@media (max-width:700px)': { width: '100%', py: '36px', borderRight: 'none', borderBottom: '1px solid rgba(120,150,200,.16)' },
        }}
      >
        <EngGrid opacity={0.45} />
        {/* Teal glow */}
        <Box sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', background: 'radial-gradient(500px 400px at 30% 60%, rgba(45,212,191,.12), transparent 65%)' }} />
        <Box sx={{ position: 'relative' }}>
          <Logo size={34} to="/" sx={{ mb: '36px' }} />
          <Box sx={{ fontFamily: MONO, fontSize: '11.5px', letterSpacing: '.14em', textTransform: 'uppercase', color: '#2dd4bf', mb: '14px' }}>
            {`// P&ID Intelligence`}
          </Box>
          <Box sx={{ fontSize: '24px', fontWeight: 700, color: '#f4f8ff', lineHeight: 1.3, mb: '12px', letterSpacing: '-.01em' }}>
            Turn P&IDs into structured, validated data.
          </Box>
          <Box sx={{ fontSize: '14px', color: '#8298bd', lineHeight: 1.6 }}>
            Upload a drawing — AI detects every element, instrument, line and tag. Verify and export.
          </Box>
          {statusLine && (
            <Box sx={{ mt: '32px', fontFamily: MONO, fontSize: '12px', color: '#4f6a8a', borderTop: '1px solid rgba(120,150,200,.14)', pt: '18px' }}>
              {statusLine}
            </Box>
          )}
        </Box>
      </Box>

      {/* Form panel */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: '24px', sm: '48px', md: '64px' },
          py: '48px',
          background: '#0b1730',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '420px' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
